import React from "react"
import Store from "../ComuniStore"
import Actions from "../ComuniActions"
import { Comune } from "../../generated";

interface IProps {
    codFisComune: string | undefined | null;
    selector: (stop: Comune | null) => string | JSX.Element;
}
interface IState {
    stored: Comune | null;
}

export const ComuneDescription = (props: { codFisComune: string }) => <ComuneData codFisComune={props.codFisComune} selector={x => x?.nomeComune ?? ""} />
export class ComuneData extends React.Component<IProps, IState>{
    constructor(props: IProps) {
        super(props);
        this.state = { stored: props.codFisComune ? Store.get(props.codFisComune) : null };
    }

    listener = () => {
        const stop = this.props.codFisComune && Store.get(this.props.codFisComune) || null;
        if (this.state.stored != stop)
            this.setState({ stored: stop });
    }

    componentDidMount() {
        Store.Changed.register(this.listener);
        if (!this.state.stored && this.props.codFisComune)
            Actions.get(this.props.codFisComune)
    }

    componentDidUpdate(oldProps: IProps) {
        if (this.props.codFisComune !== oldProps.codFisComune && this.props.codFisComune) {
            let stored = Store.get(this.props.codFisComune);
            if (!stored)
                Actions.get(this.props.codFisComune);
            else {
                this.setState({ stored });
            }
        }
    }

    componentWillUnmount() {
        Store.Changed.unregister(this.listener);
    }

    static getStop(id: string) {
        return Store.get(id);
    }

    render() {
        const comune = this.state.stored;
        const content = this.props.selector(comune);
        return content;
    }
}